import React from "react";
import classNames from "../classNames";

const defaultProps = {
  title: "Status Legend",
  items: [
    {
      label: "Open",
      color: "#ffffff",
      description: "You can still add transactions",
      border: "gray",
      size: "0.9rem",
    },
    {
      label: "Audited",
      color: "#cfe2ff",
      description: "Finalized — no more changes",
      border: "gray",
      size: "0.9rem",
    },
    {
      label: "Submitted",
      color: "#fff3cd",
      description: "Sent for audit — waiting for review",
      border: "gray",
      size: "0.9rem",
    },
  ],
  className: "",
  compact: false,
};

function LegendBox({ title, items, className, compact }) {
  return (
    <div className={classNames(`card border-1 border-dark-subtle`, className)}>
      <div className="card-body p-3">
        <div
          className="d-flex align-items-center mb-3 pb-2"
          style={{ borderBottom: "1px solid #e9ecef" }}
        >
          <div
            className="d-flex align-items-center justify-content-center me-2 rounded-1 bg-primary"
            style={{
              width: "24px",
              height: "24px",
            }}
          >
            <i
              className="bi bi-grid-3x3-gap-fill text-white"
              style={{ fontSize: "11px" }}
            ></i>
          </div>
          <h6
            className="mb-0 fw-semibold"
            style={{
              fontSize: "13px",
              color: "#495057",
              letterSpacing: "0.3px",
            }}
          >
            {title}
          </h6>
        </div>

        <div className={compact ? "d-flex flex-wrap gap-2" : ""}>
          {items.map((item, index) => (
            <div
              key={index}
              className={classNames(
                "d-flex align-items-start position-relative",
                !compact ? "mb-2" : "",
              )}
              style={{
                padding: "8px 10px",
                borderRadius: "6px",
                transition: "all 0.2s ease",
                cursor: "pointer",
                background: "transparent",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#f8f9fa";
                e.currentTarget.style.transform = "translateX(4px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.transform = "translateX(0)";
              }}
            >
              <span
                className="me-2 mt-1"
                style={{
                  display: "inline-block",
                  width: item.size || "10px",
                  height: item.size || "10px",
                  backgroundColor: item.color,
                  border: item.border ? `1px solid ${item.border}` : "none",
                  borderRadius: item.shape === "circle" ? "50%" : "2px",
                  boxShadow: `0 0 8px ${item.color}40`,
                  transition: "all 0.2s ease",
                  flexShrink: 0,
                }}
              ></span>

              <div className="flex-grow-1">
                <div className="d-flex align-items-center">
                  <span
                    className="flex-grow-1 fw-medium"
                    style={{
                      fontSize: "13px",
                      lineHeight: "1.4",
                    }}
                  >
                    {item.label}
                  </span>

                  {item.count !== undefined && (
                    <span
                      className="ms-2"
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        color: "#495057",
                        background: "#e9ecef",
                        padding: "2px 8px",
                        borderRadius: "10px",
                        minWidth: "24px",
                        textAlign: "center",
                      }}
                    >
                      {item.count}
                    </span>
                  )}
                </div>

                {/* Description */}
                {item.description && (
                  <div
                    className="fw-medium"
                    style={{
                      fontSize: "12px",
                      color: "#868e96",
                      marginTop: "2px",
                      lineHeight: "1.4",
                    }}
                  >
                    {item.description}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

LegendBox.defaultProps = defaultProps;

export default LegendBox;
